import type { PurchaseDemand, PurchaseDemandQueryParam } from "../../../../common/types/intend";
import type { PurchaseDemandForm, Page, PurchaseDemandVo } from "@zhihaoscm/entity";
import httpRequest from "@/api/index";

export class IntendService {
    private readonly path: string;
    private service: any;

    constructor(path: string, service: any) {
        this.path = path;
        this.service = service;
    }

    /**
     * 按 ID 获取对象
     * @param id
     */
    async getInfo(id: number | string): Promise<PurchaseDemandVo> {
        const { data } = await this.service.get(`${this.path}/vo/${id}`);
        return data;
    }

    /**
     * 关闭购买意向
     */
    async close<_C, T>(id: number | string): Promise<T> {
        const { data } = await this.service.put(`${this.path}/close/${id}`);
        return data;
    }

    /**
     * 确认信息
     */
    async confirmInfo(id: number | string) {
        const { data } = await this.service.post(`${this.path}/notarize/${id}`);
        return data;
    }

    /** 意向大厅 */
    async intendHall(params: { page: number; size: number; priceType?: number }): Promise<Page<PurchaseDemand>> {
        const { data } = await this.service.get(`/purchase-demand/hall`, { params });
        return data;
    }

    /** 出资 */
    async contribute(id: number) {
        const { data } = await this.service.post(`${this.path}/capitalContribution/${id}`);
        return data;
    }

    /** 分页查询购买意向 */
    async paging(params: PurchaseDemandQueryParam): Promise<Page<PurchaseDemand>> {
        const { data } = await this.service.get(`${this.path}/custom-paging`, { params });
        return data;
    }

    /** 新增购买意向 */
    async createIndent(params: PurchaseDemandForm) {
        const { data } = await this.service.post(`${this.path}`, params);
        return data;
    }
}
export const intendService = new IntendService("/purchase-demand", httpRequest);
